/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["[_nghost-%COMP%]{z-index:10000;position:fixed;top:0;left:0;width:100%;height:100%;background-color:rgba(23,22,39,.8);display:flex;overflow-y:scroll}[_nghost-%COMP%]   .modal-container[_ngcontent-%COMP%]{margin:auto}[no-scroll][_nghost-%COMP%]{overflow-y:unset}"];
export { styles as styles };
